import { MdClose } from 'react-icons/md'
import UserAppContext from '../../hook/UserAppContext'
import './relation.css'
const Relation = ({isRelationship, isSetRelation}) => {

      const closeRelation = () => {
            isSetRelation(false)
      }

      const {user, data} = UserAppContext()
      const {relation} = user.user 

      const name = relation.data || relation.name === '' ? data.relation.name : relation.name
      const avatar = relation.data || relation.avatar === '' ? data.relation.avatar : relation.avatar
      const about = relation.data || relation.about === '' ? data.relation.about : relation.about
      const me = relation.data || relation.me === '' ? data.relation.me : relation.me

      return (
            <div className={isRelationship ? "wrapper_relation show" : "wrapper_relation"}>
                  <button className="close_relation" onClick={() => closeRelation()}><MdClose/></button>
                  <div className="relation_avatar">
                        <img src={avatar} alt={name} />
                  </div>
                  <h2 className="bg_grad">{name}</h2>
                  <span>{relation.relation_type}</span>
                  <div className="relation_about">
                        <p>{about}</p>
                  </div>
                  <a href={me} target="_blank" rel="noreferrer">xat.me</a>
            </div>
      )
}

export default Relation
